
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.13 15.55"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M5.57 15.55l-.25-.13a11.53 11.53 0 0 1-2.65-2 9.85 9.85 0 0 1-1.83-2.57A8 8 0 0 1 0 7.28V1.35A1.34 1.34 0 0 1 1.35 0h8.44a1.34 1.34 0 0 1 1.34 1.35v5.93a8 8 0 0 1-.84 3.57 9.81 9.81 0 0 1-1.82 2.53 11.77 11.77 0 0 1-2.65 2zM1.35 1.09a.26.26 0 0 0-.26.26v5.93a6.94 6.94 0 0 0 .73 3.08 8.63 8.63 0 0 0 1.63 2.26 10.65 10.65 0 0 0 2.12 1.68 11 11 0 0 0 2.14-1.71 8.61 8.61 0 0 0 1.61-2.24A6.92 6.92 0 0 0 10 7.28V1.35a.26.26 0 0 0-.25-.26z"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"2.33","cy":"2.22","r":".49"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"3.92","cy":"2.22","r":".49"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M1.09 3.45h8.95v1.09H1.09zM4.69 10.66L2.51 8.48a.53.53 0 0 1 0-.77.55.55 0 0 1 .77 0l1.41 1.41L7.86 6a.53.53 0 0 1 .77 0 .55.55 0 0 1 0 .77z"}})])])])
          )
        }
      }
    